import React from "react";
import classNames from "classnames";
import "./index.scss";

const AutoRefreshIndicator = ({ t, isAutoRefresh }) => {
    return (
        <div className={classNames("autoRefreshIndicator", { active: isAutoRefresh })}>
            <span className="autoRefreshIndicatorDot" />
            <span className="autoRefreshIndicatorLabel">
                {isAutoRefresh ? t("orders.AUTO_REFRESH_ACTIVE_LABEL") : t("orders.AUTO_REFRESH_NOT_AVAILABLE_LABEL")}
            </span>
        </div>
    );
};

export default AutoRefreshIndicator;
